// extracted by mini-css-extract-plugin
export default {"regexInputContainer":"DefinitionRegexEditor-module__regexInputContainer--QfDiV","testRegexButton":"DefinitionRegexEditor-module__testRegexButton--v5t0G"};